import { Row, Col } from "antd";
import {
  ObjectFieldTemplateProps,
  canExpand,
  descriptionId,
  getTemplate,
  getUiOptions,
} from "@rjsf/utils";

/** The `ObjectFieldTemplate` is the template to use to render all the inner properties of an object along with the
 * title and description if available. If the object is expandable, then an `AddButton` is also rendered after all
 * the properties.
 *
 * @param props - The `ObjectFieldTemplateProps` for this component
 */
export default function RowFieldTemplate({
  description,
  properties,
  disabled,
  readonly,
  uiSchema,
  idSchema,
  schema,
  formData,
  onAddClick,
  registry,
}: ObjectFieldTemplateProps) {
  const uiOptions = getUiOptions(uiSchema);

  const DescriptionFieldTemplate = getTemplate(
    "DescriptionFieldTemplate",
    registry,
    uiOptions
  );
  // Button templates are not overridden in the uiSchema
  const {
    ButtonTemplates: { AddButton },
  } = registry.templates;
  return (
    <>
      {description && (
        <DescriptionFieldTemplate
          id={descriptionId(idSchema)}
          description={description}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      <Row gutter={16}>
      {properties.map((element, index) => {

        // Remove the <Col> if the inner element is hidden as the <Col>
        // itself would otherwise still take up space.
        if (element.hidden) {
          return element.content;
        } else {
        
          return (
            <Col span={12} key={index}>
              {element.content}
            </Col>
          );
        }
      })}
        {canExpand(schema, uiSchema, formData) && (
          <Row justify="end">
            <Col>
              <AddButton
                className="object-property-expand"
                onClick={onAddClick(schema)}
                disabled={disabled || readonly}
                uiSchema={uiSchema}
                registry={registry}
              />
            </Col>
          </Row>
        )}
      </Row>
    </>
  );
}
